import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import vmodal from 'vue-js-modal';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faClipboardList,faFileSignature,faHandsHelping,faLocationArrow,faMedal,faReply,faFilePdf,faFileWord,faUserCircle,faDownload } from '@fortawesome/free-solid-svg-icons';
import { faFacebook,faAndroid,faApple } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import store from "./store/index.js";
import VueGeolocation from 'vue-browser-geolocation';
import { BootstrapVue, AlertPlugin } from 'bootstrap-vue';
import Carousel3d from 'vue-carousel-3d';
import VueLazyload from 'vue-lazyload';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { mdbStepper, mdbInput } from "mdbvue";
 
Vue.use(VueLazyload);
Vue.use(mdbStepper, mdbInput);
/*Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '@/assets/error.png',
  loading: '@/assets/loading.gif',
  attempt: 1
})*/

Vue.use(VueGeolocation);
Vue.use(vmodal);
Vue.use(require('vue-moment'));
Vue.use(BootstrapVue);
Vue.use(AlertPlugin);
Vue.use(Carousel3d);

library.add(faClipboardList,faFileSignature,faHandsHelping,faLocationArrow,faMedal,faReply,faFilePdf,faFileWord,faFacebook,faApple,faAndroid,faUserCircle,faDownload);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.config.productionTip = false;

window['App'] = {
  initialize() {
    new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app'); 
  },
};

window.App.initialize(); 

